import "../scss/_mdi.scss";
import "photoswipe/src/css/main.scss";
import "photoswipe/src/css/default-skin/default-skin.scss";
import "tiny-slider/src/tiny-slider.scss";

import * as PhotoSwipe from "photoswipe";
import * as PhotoSwipe_UI_Defaults from "photoswipe/dist/photoswipe-ui-default";

import moment from "moment";
import Vue from "vue/dist/vue.esm.browser";

window.moment = moment;
window.Vue = Vue;

function initPhotoSwipe() {
    Array.from(document.querySelectorAll(".fi-slider"))
        .forEach(gallery => initPhotoSwipeGallery(gallery));

    Array.from(document.querySelectorAll(".photos"))
        .forEach(gallery => initPhotoSwipeGallery(gallery));
}

function initPhotoSwipeGallery(gallery) {
    const photos = Array.from(gallery.querySelectorAll(".image-thumbnail"));

    if (photos.length <= 1)
        return;

    photos.forEach((photo, index) => photo.addEventListener("click", evt => launchGallery(evt, gallery, photos, index)));
}

function launchGallery(evt, gallery, photos, index) {
    evt.preventDefault();
    evt.stopPropagation();

    const options = {index, showHideOpacity: true};
    const pswp = document.querySelector(".pswp");

    const items = photos.map(photo => ({
        src: photo.getAttribute("href"),
        h: parseInt(photo.dataset.height),
        w: parseInt(photo.dataset.width)
    }));

    const photoSwipeGallery = new PhotoSwipe(pswp, PhotoSwipe_UI_Defaults, items, options);
    photoSwipeGallery.init();
}

window.addEventListener("load", initPhotoSwipe);
